import type { Variants } from 'framer-motion';

// Direction-aware step transition: `custom` on the enclosing `motion.div` should be
// 1 when moving forward through the wizard, -1 when moving back.
export const stepVariants: Variants = {
  initial: (direction: number) => ({
    opacity: 0,
    y: direction > 0 ? 32 : -32,
    scale: 0.97,
  }),
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.45,
      ease: [0.16, 1, 0.3, 1],
    },
  },
  exit: (direction: number) => ({
    opacity: 0,
    y: direction > 0 ? -24 : 24,
    scale: 0.98,
    transition: {
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1],
    },
  }),
};

// Used instead of `stepVariants` when the user has `prefers-reduced-motion` set:
// keeps the opacity crossfade (so the transition doesn't feel broken) but drops
// the directional slide/scale motion.
export const reducedMotionStepVariants: Variants = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 0.15 },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.15 },
  },
};
